// start:ng42.barrel
import './transport-timeslot-add.component';
import './transport-timeslot-edit.component';
import './transport-timeslots.component';
// end:ng42.barrel

